import { saveAs } from 'file-saver';

/**
 * Imprime le bon depuis une iframe hors écran : elle n'imprime que l'image,
 * sans le dashboard autour, et n'est pas bloquée par les popup blockers
 * (contrairement à un window.open).
 */
export const printGiftcard = (url: string): void => {
  const iframe = document.createElement('iframe');
  iframe.setAttribute('aria-hidden', 'true');
  iframe.style.position = 'fixed';
  iframe.style.right = '0';
  iframe.style.bottom = '0';
  iframe.style.width = '0';
  iframe.style.height = '0';
  iframe.style.border = '0';

  // Retrait différé : dans Chrome, print() rend la main dès l'ouverture de la
  // boîte de dialogue — retirer l'iframe trop tôt viderait l'aperçu.
  const cleanup = () => window.setTimeout(() => iframe.remove(), 1000);

  const fallback = () => {
    window.open(url, '_blank', 'noopener');
    cleanup();
  };

  iframe.onload = () => {
    const win = iframe.contentWindow;
    const doc = iframe.contentDocument;
    if (!win || !doc) {
      fallback();
      return;
    }

    const style = doc.createElement('style');
    style.textContent = `
      @page { size: auto; margin: 10mm; }
      html, body { margin: 0; padding: 0; }
      img { width: 100%; height: auto; display: block; }
    `;
    doc.head.appendChild(style);

    const img = doc.createElement('img');
    img.alt = 'Bon cadeau';
    img.onload = () => {
      win.focus();
      win.print();
      cleanup();
    };
    img.onerror = fallback;
    img.src = url;
    doc.body.appendChild(img);
  };

  iframe.src = 'about:blank';
  document.body.appendChild(iframe);
};

/**
 * Télécharge le PNG du bon. Si le fetch échoue (CORS du bucket, réseau),
 * on ouvre l'image dans un onglet : l'utilisateur peut toujours l'enregistrer.
 */
export const downloadGiftcard = async (
  url: string,
  code: string
): Promise<void> => {
  try {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`HTTP ${response.status}`);
    saveAs(await response.blob(), `boncadeau-${code}.png`);
  } catch (error) {
    console.error('❌ Téléchargement du bon impossible :', error);
    window.open(url, '_blank', 'noopener');
  }
};
